import { Spin } from 'antd';
import React, { Component } from 'react';
import ImgsViewer from 'react-images-viewer';

class PhotosViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: this.props.isOpen,
      currImg: 0,
    };

    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrev = this.gotoPrev.bind(this);
    this.gotoImg = this.gotoImg.bind(this);
    this.handleClickImg = this.handleClickImg.bind(this);
    this.openImgsViewer = this.openImgsViewer.bind(this);
  }

  openImgsViewer(index, event) {
    event.preventDefault();
    this.setState({
      currImg: index,
      isOpen: true,
    });
  }

  gotoPrev() {
    this.setState({
      currImg: this.state.currImg - 1,
    });
  }

  gotoNext() {
    this.setState({
      currImg: this.state.currImg + 1,
    });
  }

  gotoImg(index) {
    this.setState({
      currImg: index,
    });
  }

  handleClickImg() {
    if (this.state.currImg === this.state.imgs.length - 1) return;
    this.gotoNext();
  }

  render() {
    const { isOpen } = this.state;
    return (
      <ImgsViewer
        closeBtnTitle="Close"
        leftArrowTitle="Prev"
        rightArrowTitle="Next"
        backdropCloseable
        currImg={this.state.currImg}
        imgs={this.props.imgs}
        isOpen={isOpen}
        onClickImg={this.handleClickImg}
        onClickNext={this.gotoNext}
        onClickPrev={this.gotoPrev}
        onClickThumbnail={this.gotoImg}
        onClose={this.props.onClose}
        preventScroll={this.props.preventScroll}
        showThumbnails={this.props.showThumbnails}
        spinner={Spin}
      />
    );
  }
}

PhotosViewer.displayName = 'PhotosViewer';

export default PhotosViewer;
